export default __webpack_public_path__ + "img/request-loan-icon.bdb0fd33.svg";